module.exports = __webpack_public_path__ + "static/media/boton3.aec55137.svg";